import { search } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);

const path = `${process.env.REACT_APP_URL_API_REPORTS}/receivables`;

const documentsHubPath = `${process.env.REACT_APP_URL_API_DOC_HUB}/reports`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findReceivableAccounts(filterProps) {
  const url = new URL(path);
  Object.entries(filterProps).forEach(([key, value]) => {
    if (value && !value?.toString().startsWith("no-")) {
      url.searchParams.append(key, value);
    }
  });

  return search(decodeURIComponent(url), "GET", headers);
}

export async function findDashboardReceivableAccounts(filterProps) {
  const url = new URL(`${path}/dashboard`);
  Object.entries(filterProps).forEach(([key, value]) => {
    if (value && !value?.toString().startsWith("no-")) {
      url.searchParams.append(key, value);
    }
  });

  return search(decodeURIComponent(url), "GET", headers);
}

export async function printReceivableAccountsPDF(body) {
  const url = `${documentsHubPath}/account-receivable/generate`;

  return search(`${url}`, "POST", headers, body);
}
